import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  navigateButton: {
    '&&': {
      minWidth: 150,
      maxHeight: 40,
      marginRight: 'auto',

      boxShadow: `2px 4px 8px ${theme.palette.custom.grey}`,
      borderRadius: 20,

      fontSize: FONTS.SIZES.s,
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.white,
    },
  },
  buttonMb: {
    '&&': {
      marginBottom: SPACES.xxl,
    },
  },
}))
